// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"MobileDeclineBody_modal_body__3qzTz","footer":"MobileDeclineBody_footer__EtmxT"};